import { z } from 'zod';
import { SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';
import {
  CandidateOppFeedAlertsConst,
  CountryCodesConst,
  EngagementLengthConst,
  PositionsConst,
  TimeCommitment,
} from '@axiom/const';

const { CountryCodes } = CountryCodesConst;
const { Worksites } = PositionsConst;
const { EngagementLengths } = EngagementLengthConst;
const { Frequency } = CandidateOppFeedAlertsConst;

export const CandidateAlertWorkFeedEngagementLengths =
  Object.values(EngagementLengths);

export const CandidateAlertWorkFeedTimeCommitments = Object.values(
  TimeCommitment.HoursPerWeek
);

export const CandidateAlertWorkFeedWorksites = Object.values(Worksites);

export const CandidateAlertWorkFeedCountryCodes = Object.keys(
  CountryCodes
) as Array<keyof typeof CountryCodes>;

export const CandidateAlertWorkFeedFrequencies = Object.values(Frequency);

export const CandidateAlertWorkFeedSchema = z.object({
  alertName: z.string().max(255),
  businessTitles: z.array(z.string()).nullish(),
  countries: z
    .array(z.enum(ZodArrayToEnum(CandidateAlertWorkFeedCountryCodes)))
    .nullish(),
  createdAt: SchemaTimestamp.nullable(),
  engagementLengths: z
    .array(z.enum(ZodArrayToEnum(CandidateAlertWorkFeedEngagementLengths)))
    .nullish(),
  frequency: z.enum(ZodArrayToEnum(CandidateAlertWorkFeedFrequencies)),
  id: z.string().uuid().nullish(),
  industries: z.array(z.string()).nullish(),
  practiceAreas: z.array(z.string()).nullish(),
  focusAreas: z.array(z.string()).nullish(),
  updatedAt: SchemaTimestamp.nullable(),
  weeklyCommitments: z
    .array(z.enum(ZodArrayToEnum(CandidateAlertWorkFeedTimeCommitments)))
    .nullish(),
  worksites: z
    .array(z.enum(ZodArrayToEnum(CandidateAlertWorkFeedWorksites)))
    .nullish(),
});

export type CandidateAlertWorkFeed = z.infer<
  typeof CandidateAlertWorkFeedSchema
>;
